import classnames from 'classnames';
import type {
  RibbonSize,
  Placement,
  RibbonWithoutPlacement,
  RibbonWithPlacement,
} from './types';
import styles from './index.module.less';
import { Icon } from '../icon';

interface CommonProps {
  size: RibbonSize;
  children?: React.ReactNode;
  imageName?: string;
  className?: string;
  qeId?: string;
}

type ConditionalProps =
  | {
      type: RibbonWithoutPlacement;
      placement?: never;
    }
  | {
      type: RibbonWithPlacement;
      placement: Placement;
    };

type Props = CommonProps & ConditionalProps;

export const RibbonV2 = ({
  children,
  className,
  qeId,
  placement,
  imageName,
  size,
  type,
}: Props) => {
  const variant = placement
    ? `${type}_${size}_${placement}`
    : `${type}_${size}`;
  return (
    <div
      data-testid={qeId ?? `${variant}_ribbon`}
      className={classnames(
        styles.root,
        styles[size],
        styles[type],
        styles[variant],
        className
      )}
    >
      {imageName && <Icon imageName={imageName} directory="dls" />}
      {children}
    </div>
  );
};
